import type { FC } from 'react';
import './Separator.css';

interface SeparatorProps {
  text?: string;
  className?: string;
}

const Separator: FC<SeparatorProps> = ({ text, className = '' }) => (
  <div className={'decorated ' + className}>{text && <span>{text}</span>}</div>
);

export default Separator;
